export enum StatusEnum {
    OPEN = 'OPEN',
    ACCEPTED = 'ACCEPTED',
    INPROGRESS='INPROGRESS',
    FAILED = 'FAILED',
    SUCCESS = 'SUCCESS'

  }

  export enum BuyerEnum {
    TommyEurope = 'TommyEurope',
    TommyNorthAmerica = 'TommyNorthAmerica',
    CKNorthAmerica = 'CKNorthAmerica',
    CKEurope = 'CKEurope',
  }
